import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SvgCacheService {
  private cache = new Map<string, Observable<SafeHtml>>();

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  getIcon(iconName: string): Observable<SafeHtml | undefined> {
    if (!iconName) {
      return of(undefined);
    }

    if (this.cache.has(iconName)) {
      return this.cache.get(iconName)!;
    }

    const request = this.httpClient
      .get(`assets/icons/${iconName}.svg`, { responseType: 'text' })
      .pipe(
        map(svgString => this.sanitizer.bypassSecurityTrustHtml(svgString)),
        catchError(() => {
          return of(undefined);
        }),
        tap(safeHtml => {
          if (safeHtml === undefined) {
            this.cache.delete(iconName);
          }
        }),
        shareReplay(1)
      );

    this.cache.set(iconName, request);
    return request;
  }

  preloadIcons(iconNames: string[]): void {
    iconNames.forEach(name => {
      if (!this.cache.has(name)) {
        this.getIcon(name).subscribe();
      }
    });
  }
}
